import { VisitOptions } from '@inertiajs/core/types/types'
import { router } from '@inertiajs/vue3'

export function inertiaModalVisit(
  href: string | URL,
  parameters?: VisitOptions,
): void {
  // const appRoles = userData.value?.appRoles || []
  const params: VisitOptions = {
    preserveScroll: true,
    preserveState: true,
    ...parameters,
  }

  // params['onError'] = errors => {
  //   console.log(errors)
  // }

  // if (appRoles.includes('Standard User')) {
  //   params['only'] = ['modal']
  // }
  router.visit(href, params)
}
